import type {SyntheticEvent} from 'react'
import {useRef} from 'react'
import {Button} from '@freckle/educator-materials/ts/components/button'
import * as style from './upload-file-button.module.scss'

type Props = {
  buttonText: string
  onPostFileUpload: (file: File) => void
  isDisabled?: boolean
}

type TargetWithFiles = EventTarget & {files: File[]}

export function UploadFileButton(props: Props) {
  const {isDisabled = false, buttonText, onPostFileUpload} = props

  const hiddenInputRef = useRef<HTMLInputElement | null>(null)

  function uploadFile(e: SyntheticEvent<EventTarget, Event>) {
    const fileInputValue = (e.target as TargetWithFiles).files[0]!
    onPostFileUpload(fileInputValue)
  }

  function onButtonClick() {
    if (hiddenInputRef.current !== null) {
      //used to force onChange event to fire on every file upload even if file is the same.
      hiddenInputRef.current.value = ''
      hiddenInputRef.current.click()
    }
  }

  return (
    <div className={style.uploadInputWrapper}>
      <input
        type="file"
        onChange={uploadFile}
        ref={hiddenInputRef}
        className={style.inputElement}
      />
      <Button
        style="secondary"
        onClick={onButtonClick}
        disabled={isDisabled}
        dataTest="upload-file-button"
      >
        {buttonText}
      </Button>
    </div>
  )
}
